import { Switch, FormControl, FormControlLabel, FormGroup, FormLabel } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import React from 'react'

export default function SwitchWrapper({
    name,
    label,
    legend = '',
    ...otherProps
}) {
    const { setFieldValue } = useFormikContext()

    const [field, meta] = useField(name)

    const handleChange = event => {
        const { checked } = event.target
        setFieldValue(name, checked)
    }

    const configSwitch = {
        ...field,
        ...otherProps,
        checked: field.value,
        onChange: handleChange
    }

    const configFormControl = {}

    if (meta && meta.touched && meta.error) {
        configFormControl.error = true
    }

    return (
        <FormControl {...configFormControl}>
            {legend ? <FormLabel component="legend">{legend}</FormLabel> : ''}
            <FormGroup>
                <FormControlLabel
                    control={<Switch {...configSwitch} />}
                    label={label}
                />

            </FormGroup>
        </FormControl>
    )
}
